var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './footer.scss';
import parse from 'html-react-parser';
export var footerData = {
    menuItems: [
        {
            label: 'Our Brands',
            url: '',
            isActive: false,
            items: [
                {
                    label: 'Envestnet | PMC',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Envestnet | Yodlee',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Envestnet | Tamarac',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Envestnet | MoneyGuide',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Envestnet | Retirement Solutions',
                    url: '',
                    isActive: false,
                },
            ],
        },
        {
            label: 'Developer Tools',
            url: '',
            isActive: false,
            items: [
                {
                    label: 'Developer Portal',
                    url: '',
                    isActive: false,
                },
            ],
        },
        {
            label: 'Company',
            url: '',
            isActive: false,
            items: [
                {
                    label: 'Our Leadership',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Giving Back',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Contact Us',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Investor Relations',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Brand Guidelines',
                    url: '',
                    isActive: false,
                },
                {
                    label: 'Careers',
                    url: '',
                    isActive: false,
                },
            ],
        },
    ],
    cardItems: {
        cardText: 'See how you can empower the Intelligent Financial Life\u2122',
        cardCtaText: 'Schedule a demo',
        cardCtaLink: '/sch-demo',
        copyrightText: '\u00a9 2008\u20132022 Envestnet. All rights reserved.',
        copyrightSubText: 'This website is for investment professionals only. It is not intended for private investors. Private investors who are interested in our investment services should contact a financial professional.',
    },
};
export var Footer = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var data = props && props.data ? props.data : footerData;
    var copyRight = (_a = data.cardItems) === null || _a === void 0 ? void 0 : _a.copyrightText;
    var copyRightDisclaimer = (_b = data.cardItems) === null || _b === void 0 ? void 0 : _b.copyrightSubText;
    var today = new Date();
    var year = today.getFullYear();
    return (_jsxs("footer", __assign({ className: "footer snap-center relative min-h-full footer-gray-border" }, { children: [((_c = data.menuItems) === null || _c === void 0 ? void 0 : _c.length) <= 3 && (_jsx("div", __assign({ className: "footer__nav" }, { children: data !== undefined &&
                    ((_d = data.menuItems) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                    ((_e = data.menuItems) === null || _e === void 0 ? void 0 : _e.map(function (item) {
                        return (_jsxs("nav", __assign({ className: "footer-nav__links" }, { children: [_jsx("a", __assign({ href: item.url, className: "footer-nav__links-header" }, { children: item.label }), void 0),
                                item.items && item.items.length > 0 && (_jsx("ol", __assign({ className: "footer-nav__links-list" }, { children: item.items.map(function (dropdownItem) {
                                        return (_jsx("li", { children: _jsx("a", __assign({ href: dropdownItem.url, rel: "noreferrer", target: dropdownItem.isExternal != null
                                                    ? dropdownItem.isExternal == '0'
                                                        ? '_self'
                                                        : '_blank'
                                                    : '_self' }, { children: _jsx("p", { children: dropdownItem.label }, void 0) }), void 0) }, dropdownItem.label));
                                    }) }), void 0))] }), item.label));
                    })) }), void 0)),
            ((_f = data.menuItems) === null || _f === void 0 ? void 0 : _f.length) == 4 && (_jsx("div", __assign({ className: "footer__nav footer__nav__four" }, { children: data !== undefined &&
                    ((_g = data.menuItems) === null || _g === void 0 ? void 0 : _g.length) > 0 &&
                    ((_h = data.menuItems) === null || _h === void 0 ? void 0 : _h.map(function (item) {
                        return (_jsxs("nav", __assign({ className: "footer-nav__links footer-nav__links__four" }, { children: [_jsx("a", __assign({ href: item.url, className: "footer-nav__links-header" }, { children: item.label }), void 0),
                                item.items && item.items.length > 0 && (_jsx("ol", __assign({ className: "footer-nav__links-list" }, { children: item.items.map(function (dropdownItem) {
                                        return (_jsx("li", { children: _jsx("a", __assign({ href: dropdownItem.url, rel: "noreferrer", target: dropdownItem.isExternal != null
                                                    ? dropdownItem.isExternal == '0'
                                                        ? '_self'
                                                        : '_blank'
                                                    : '_self' }, { children: _jsx("p", { children: dropdownItem.label }, void 0) }), void 0) }, dropdownItem.label));
                                    }) }), void 0))] }), item.label));
                    })) }), void 0)),
            data !== undefined && data.cardItems !== undefined && (_jsxs("div", __assign({ className: "\"footer__demo md:pl-0 lg:pl-72\" " + (((_j = data.menuItems) === null || _j === void 0 ? void 0 : _j.length) == 4 ? 'footer__demo_four' : '') }, { children: [_jsxs("div", __assign({ className: "footer-demo__sheet" }, { children: [_jsx("span", __assign({ className: "footer-demo__sheet-text" }, { children: data.cardItems.cardText }), void 0),
                            _jsx("div", __assign({ className: "footer-demo__schedule-button-container" }, { children: _jsx("a", __assign({ href: data.cardItems.cardCtaLink, className: "footer-demo__schedule-button footer-demo__schedule-button--animate" }, { children: _jsx("span", { children: data.cardItems.cardCtaText }, void 0) }), void 0) }), void 0)] }), void 0),
                    copyRight && (_jsxs("div", __assign({ className: "footer-demo__sheet-copyright" }, { children: [_jsxs("p", __assign({ className: "footer-year" }, { children: ["\u00A9 2008\u2013", year] }), void 0), parse(copyRight)] }), void 0)),
                    copyRightDisclaimer && (_jsx("div", __assign({ className: "footer-demo__sheet-disclaimer" }, { children: parse(copyRightDisclaimer) }), void 0))] }), void 0))] }), void 0));
};
